import DeletePage from './DeletePage';

export default DeletePage;
